module.exports = __webpack_public_path__ + "img/service_testing_7_mob.c20da290.jpg";